'use client';

import * as React from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
import { fadeInUp } from '@/lib/motion';

type RevealProps = {
  children: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  distance?: number;
  duration?: number;
  delay?: number;
  once?: boolean;
  amount?: number; // 0..1 viewport threshold
};

export function Reveal({
  children,
  as = 'div',
  className,
  distance = 24,
  duration = 0.6,
  delay = 0,
  once = true,
  amount = 0.2,
}: RevealProps) {
  const Comp = (motion as any)[as] ?? motion.div;
  const ref = React.useRef<HTMLElement | null>(null);
  const rm = useReducedMotion();
  const inView = useInView(ref, { amount, once });

  return (
    <Comp
      ref={ref as any}
      className={className}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={fadeInUp(distance, rm, duration, delay)}
    >
      {children}
    </Comp>
  );
}

